
import Icon from 'JS/components/Icon.vue';
import SavedVehicle from 'JS/components/automotive/SavedVehicle.vue';
import { computed, defineComponent } from "vue";
import { ISavedVehicle } from 'JS/types/Automotive';
import { PropType } from 'vue';

export default defineComponent({
	name: "WorkOrderVehicle",
	components: {
		Icon,
		SavedVehicle
	},
	props: {
		vehicleInfo: { type: Object as PropType<ISavedVehicle> }
	},
	setup(props) {
		const getLayout = computed(() => props.vehicleInfo.iconType == null ? 'no-icon' : 'scheduler');
		return {
			getLayout
		};

	}
});
